// @flow
import React from 'react';
import { List } from 'immutable';
import isEmpty from 'lodash/isEmpty';

import Dropdown from '../../../FormControls/Dropdown';

type Props = {
  input: {
    value: Object,
    onChange: (e: any) => void,
  },
};

const CustomDropdown = (props: Props) => {
  const { input, ...rest } = props;
  const { value, onChange } = input;

  return (
    <Dropdown
      {...rest}
      input={{
        ...input,
        value: value.toJS ? value.toJS() : value,
        onChange: (newValue) => onChange(List(!isEmpty(newValue) ? newValue : [])),
      }}
      isMulti
      required
    />
  );
};

export default CustomDropdown;
